export default class Viewport {

  constructor(selector) {
    this.html = document.querySelector('html');
    this.header = document.getElementById('header');
    this.currentWidth = null;

    window.addEventListener('resize', (e) => {
      this.resizeHandler(e);
    });

    setTimeout(() => {
      this.resizeHandler(null, true);
    }, 1);
  }


  resizeHandler(event, force = false) {
    // if (this.isTouchDevice() && window.innerWidth == this.currentWidth) {
    //   return;
    // }

    this.html.setAttribute('style', '--vh:' + window.innerHeight + 'px; ' + ' --vh-h:' + (window.innerHeight - this.header.clientHeight) + 'px;' + ' --hh:' + this.header.clientHeight + 'px;');
    this.currentWidth = window.innerWidth;
  }


  isTouchDevice() {
    return (('ontouchstart' in window) ||
      (navigator.maxTouchPoints > 0) ||
      (navigator.msMaxTouchPoints > 0));
  }

}